export default __webpack_public_path__ + "static/media/SeaLife_31.8be5cf72.png";